class FilterBase {
    ToQueryParams(): Record<string, string> {
        const items: Record<string, string> = {}

        Object.entries(this).forEach(([key, value]) => {
            if (value != null && value != undefined) {
                // items[encodeURIComponent(key)] = encodeURIComponent(value.toString()) // Do not double encode
                items[key] = value.toString();
            }
        });
        return items
    }
}

export default FilterBase
